import VideoFlat from '../src/VideoFlat';
export default VideoFlat;
